
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[state]",
      function () {
        return require("private-next-pages/[state]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[state]"])
      });
    }
  